import React, { useState, useEffect } from 'react';
import { absoluteUrl } from '../../lib/api';
import { avatarInitials } from './forumUtils';

// Avatar with the interpreter's real photo when available, else gradient initials.
export function Avatar({ name, photoUrl, size = 44 }) {
  const s = { width: size, height: size };
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [photoUrl]);
  if (photoUrl && !failed) {
    return (
      <img
        src={absoluteUrl(photoUrl)} alt={name} loading="lazy" style={s}
        className="rounded-2xl object-cover flex-shrink-0 ring-1 ring-slate-200 shadow-sm"
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <div style={s} className="rounded-2xl bg-gradient-to-br from-cmic-500 to-cmic-700 text-white flex items-center justify-center font-semibold text-sm flex-shrink-0 shadow-sm">
      {avatarInitials(name)}
    </div>
  );
}

export default Avatar;
